import { render } from "./QnAPage.vue?vue&type=template&id=9e6ca16a&scoped=true"
import script from "./QnAPage.vue?vue&type=script&lang=js"
export * from "./QnAPage.vue?vue&type=script&lang=js"

import "./QnAPage.vue?vue&type=style&index=0&id=9e6ca16a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e6ca16a"]])

export default __exports__